<template>
  <div class="category-page">
    <div class="category-list" :style="'transition:margin-top 1s; margin-top:-' + listheight * scrolls + 'px;'">
      <div class="category-list-item" v-for="(item, index) in categorylist" :key="index">
        <div class="category-list-item-inner">
          <h2>{{ item.name_cn }}</h2>
          <ul>
            <li v-for="subitem in item.categoryList" :key="subitem.cid">
              <el-button v-if="subitem.is_display/1 == 1" type="text" size="mini" @click="goToDashboard(subitem.cid)">
                {{ subitem.name_cn }}
              </el-button>
              <i @click="showInfo(subitem)" class="el-icon-warning-outline"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  
    <div 
      class="scrollcategorylist" 
      v-if="showscrollcategorybtn" 
      :style="'padding-top:' + (listheight/2 - (25 * reportcategoryrows)/2) + 'px;'"
    >
      <el-button
        :class="currentrow == item ? 'activescrollbtn' : ''"
        v-for="(item, index) in reportcategoryrows" 
        :key="index" 
        @click="scrollcategory(item-1)"
      >
      </el-button>
    </div><!-- 垂直切换 -->

    <el-dialog :title="categoryinfo.name_cn" :visible.sync="showcategroyinfo" width="60%" show-close custom-class="categoryinfobox">
      <h2>包括海关8位码数量：{{ categoryinfo.code_amount }}</h2>
      <h2>品类包括：</h2>
      <p v-for="(c, index) in categoryinfo.include_cn" :key="index">{{ c }}</p>
      <h2 class="captiontitle">说明：</h2>
      <p v-for="(c, index) in categoryinfo.caption_cn" :key="index+99999">{{ c }}</p>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
      categorylist: [],
      showcategroyinfo: false,
      categoryinfo: {},
      scrolls: 0,
      listheight: window.innerHeight/1 - 160,
      showscrollcategorybtn: false,
      currentrow: 1,
    }
  },

  mounted(){
    this.getCategoryList()
  },

  methods: {

    /**
     * 右侧滚动
     */
    scrollcategory: function(i){
      this.scrolls = i
      this.currentrow = i + 1
    },

    /**
     * Category List
     */
    getCategoryList: function(){
      let that = this
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/category/list?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log(rex)
          that.categorylist = rex.data.list
          that.showscrollcategorybtn = that.categorylist.length > 10 ? true : false
          that.reportcategoryrows = Math.ceil(that.categorylist.length/10)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * Category Info
     */
    getCategoryInfo: function(cid){
      let that = this
      that.categoryinfo = {}
      let url = 'http://dashboard.api.trade-intelligence.com/dashboard/category/info?key='
                  +that.getLocalStorage('key')
                  +'&token='+that.getLocalStorage('token')
                  +'&lang='+that.getLang()
                  +'&cid='+cid+''
      $.ajax(url, {
        type: "GET",
        contentType: "application/json",
        success: function(rex) {
          console.log(rex)
          that.categoryinfo = rex.data
          that.categoryinfo.include_cn = rex.data.include_cn.split('\n')
          that.categoryinfo.caption_cn = rex.data.caption_cn.split('\n')
          that.categoryinfo.include_en = rex.data.include_en.split('\n')
          that.categoryinfo.caption_en = rex.data.caption_en.split('\n')
          that.showcategroyinfo = true
          console.log(that.categoryinfo)
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    showInfo: function(subitem){
      this.getCategoryInfo(subitem.cid)
    },

    /**
     * 跳转至Dashboard
     */
    goToDashboard: function(cid){
      this.$router.push({name: 'Dashboardpage', params: {Cid: cid}})
    },

  }
}
</script>